import React from 'react';

/**
 * Mission target — stamped tin badge to match the robot pieces.
 * Filled plate + walnut outline + inner ring + glint. No <defs>/gradients:
 * url(#id) fragment refs break under CRA's <base href>.
 */
// Takes no props: the pinwheel is always four-coloured, so Tile's `color`
// (the mission's "any") is deliberately ignored.
function UltimateIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      style={{ display: 'block' }}
    >
      {/*
        The pinwheel is drawn around (17.45, 17.15) and its round caps reach
        33.9/33.7 — past the 32-unit viewBox, so the bottom-right arcs were
        clipped. Recentre on (16, 16) and scale to a ~3–29 footprint, matching
        the circle badge. Keep the transform rather than rewriting the path
        data so the arc geometry stays as designed.
      */}
      <g transform="translate(16 16) scale(0.78) translate(-17.45 -17.15)">
        {[
          { color: '#d94f2b', d: 'M4.2 9.6c2.2-3.8 7-5.1 10.8-2.9s5.1 7 2.9 10.8' },
          { color: '#e0a325', d: 'M9.9 30.4c-3.8-2.2-5.1-7-2.9-10.8s7-5.1 10.8-2.9' },
          { color: '#2f9e6e', d: 'M30.6 24.6c-2.2 3.8-7 5.1-10.8 2.9s-5.1-7-2.9-10.8' },
          { color: '#2a63a8', d: 'M25.1 4.1c3.8 2.2 5.1 7 2.9 10.8s-7 5.1-10.8 2.9' },
        ].map(arc => (
          <g key={arc.color}>
            {/* Near-black casing (not colorWall): this icon also renders on the
                dark center plate, where a lighter casing muddies the arcs. */}
            <path d={arc.d} fill="none" stroke="#120c07" strokeWidth="6.6" strokeLinecap="round" />
            <path d={arc.d} fill="none" stroke={arc.color} strokeWidth="4.2" strokeLinecap="round" />
            <path d={arc.d} fill="none" stroke="#fff" strokeOpacity="0.28" strokeWidth="1.2" strokeLinecap="round" />
          </g>
        ))}
      </g>
    </svg>
  );
}

export default UltimateIcon;
